import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';

import './PopupCard.css';
import 'react-toastify/dist/ReactToastify.css';
import { Divider } from 'semantic-ui-react';

function PopupCard({
  cover,
  namePodcast,
  pitchPodcast,
  authorPodcast,
  icon,
  type,
  website,
}) {
  const slug = icon.replace('/icons/', '').replace('.png', '');
  const notify = () => toast.success('Lien copié !');

  return (
    <div className="card-popup">
      <div className="card-first-line">
        <div
          style={{
            width: '140px',
            height: '140px',
          }}
        >
          <img src={cover} alt={namePodcast} />
        </div>
        <div className="card-content">
          <p className="card-name">{namePodcast}</p>
          <p className="typePodcast">
            ({type === 'NATIF' ? 'Podcast natif' : 'Replay radio'})
          </p>
          <p className="card-author">{authorPodcast}</p>
        </div>
      </div>
      <div className="card-second-line">
        <p className="card-pitch">{pitchPodcast}</p>
        <a href={website} target="_blank" rel="noreferrer">
          Pour découvrir cet univers, c'est ici
        </a>
        <Divider />

        {/* <CopyToClipboard text={`https://map.audiomeans.fr/${slug}`}>
          <button onClick={notify} className="btn-copy">
            Copier le lien direct
          </button>
        </CopyToClipboard> */}
        <ToastContainer autoClose={2000} />

        <h2>Télécharger l'image dédiée</h2>
        <div className="link-container">
          <a
            href={`./out/${slug}/linkedin.png`}
            target="_blank"
            rel="noreferrer"
          >
            <p>Format paysage</p>
          </a>
          <a
            href={`./out/${slug}/instagram.png`}
            target="_blank"
            rel="noreferrer"
          >
            <p>Format carré</p>
          </a>
          <a
            href={`./out/${slug}/vertical.png`}
            target="_blank"
            rel="noreferrer"
          >
            <p>Format Vertical</p>
          </a>
        </div>
        <div className="social-container">
          <FacebookShareButton
            quote="Je suis sur la carte Podcast City"
            url={`https://map.audiomeans.fr/${slug}`}
          >
            <FacebookIcon
              className="social-icon"
              size={'3em'}
              borderRadius={'15px'}
            />
          </FacebookShareButton>
          <LinkedinShareButton
            title="Je suis sur la carte Podcast City"
            summary="Je suis sur la carte Podcast City"
            url={`https://map.audiomeans.fr/${slug}`}
          >
            <LinkedinIcon
              className="social-icon"
              size={'3em'}
              borderRadius={'15px'}
            />
          </LinkedinShareButton>
          <TwitterShareButton
            title="Je suis sur la carte Podcast City"
            url={`https://map.audiomeans.fr/${slug}`}
          >
            <TwitterIcon
              className="social-icon"
              size={'3em'}
              borderRadius={'15px'}
            />
          </TwitterShareButton>
          <EmailShareButton
            children
            subject="Je suis sur la carte Podcast City"
            body="Je suis sur la carte Podcast City"
            url={`https://map.audiomeans.fr/${slug}`}
          >
            <EmailIcon
              className="social-icon"
              size={'3em'}
              borderRadius={'15px'}
            />
          </EmailShareButton>
          {/* <WhatsappShareButton url={`https://map.audiomeans.fr/${slug}`}>
            <WhatsappIcon size={'3em'} borderRadius={'15px'} />
          </WhatsappShareButton> */}
        </div>
      </div>
    </div>
  );
}

export default PopupCard;
